export default "__VITE_ASSET__DoqgK2eg__"